/** @prettier */

import {
  Card,
  CardContent,
  Grid,
  Button,
  CircularProgress,
  Snackbar,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  Stack,
  SnackbarOrigin,
} from '@mui/material';
import {useLocation, Link, useParams} from 'react-router-dom';
import {useState, useEffect, useRef} from 'react';
import UpgradeIcon from '@mui/icons-material/Upgrade';
import AutorenewIcon from '@mui/icons-material/Autorenew';
import MoveUpOutlinedIcon from '@mui/icons-material/MoveUpOutlined';
import {format} from 'date-fns';
import {utcToZonedTime, zonedTimeToUtc} from 'date-fns-tz';
import {useTranslation} from 'react-i18next';
import LeakAddIcon from '@mui/icons-material/LeakAdd';

//MTH component import
import GearMenu, {GearMenuListArgType} from '../../component/GearMenuList';
import GWDeleteDialog from './GWDeleteDialog';
import GWEditDialog from './GWEditDialog';
import CardContents from '../../component/CardContents';
import APIErrorMessage from '../../component/APIErrorMessage';
import {PrimaryButton, SecondaryButton} from '../../component/BasicButton';
import CollectiveSettingDialog from '../collective-setting/CollectiveSettingDialog';
//API import
import {
  getCompositionsGateway,
  getCompositionsGatewayByGatewayID,
  getCompositionsSitesBySiteID,
  postCommandsGateway,
  getCompositionsRTUnit,
  postCompositionsActivation,
  getCompositionsActivation,
} from '../../API/API_Collection';
//interface import
import * as apiIF from '../../Type/api';
//Style import
import '../../css/common/common.css';

import {initialUpper} from '../../functions/convertString';
import {gwInfoSort, sortByUnicode} from '../../functions/sort';
import {apiErrorAlert} from '../../functions/apiErrorAlert';
import {limit, iconBlack} from '../../define';
import CommunicationTest from './CommunicationTestDialog';

export interface State extends SnackbarOrigin {
  open: boolean;
}
type rtUnitNumInfoType = {
  gatewayID: string;
  qtonNum: number;
  hyozanNum: number;
  chillerNum: number;
};

/**
 * アクティベート済のゲートウェイ一覧
 * @param props props
 * @returns JSX
 */
const GWSetting = (props: {
  gwInfo: apiIF.res.getCompositionsGateway | null;
  setGWInfo: React.Dispatch<
    React.SetStateAction<apiIF.res.getCompositionsGateway | null>
  >;
  timeZone: string;
  setTempActivateGW: React.Dispatch<
    React.SetStateAction<apiIF.res.getCompositionsActivation | null>
  >;
  setExchangeGW: React.Dispatch<React.SetStateAction<string[]>>;
  exchangeGW: string[];
  setRestActivationTime: React.Dispatch<React.SetStateAction<string[]>>;
}) => {
  const trans = useTranslation().t; //翻訳関数
  //URL取得
  const location = useLocation();
  //パスパラメータ取得
  const {siteID} = useParams();

  const [now, setNow] = useState(new Date()); //現在時刻
  const [clickButton, setClickButton] = useState(false); //ダイアログのOKがClickされたらTrue
  const [isOpenUpdateDialog, setIsOpenUpdateDialog] = useState(false); //アップデートダイアログ表示フラグ
  const [hasUpdateGW, setHasUpdateGW] = useState<string[]>([]); //アップデートがあるGW一覧
  const [hasConfigGW, setHasConfigGW] = useState<string[]>([]); //CONFIG UPDATEボタンを表示するGW一覧
  const [updateTarget, setUpdateTarget] = useState(''); //アップデートするゲートウェイのID
  const [nowGWVersion, setNowGWVersion] = useState(''); //現在のゲートウェイのバージョン
  const [updateGWVersion, setUpdateGWVersion] = useState<{
    [key: string]: string;
  }>({}); //アップデート後のゲートウェイのバージョン
  const [isOpenEditDialog, setIsOpenEditDialog] = useState(false); //編集ダイアログ表示フラグ
  const [isOpenDeleteDialog, setIsOpenDeleteDialog] = useState(false); //削除ダイアログ表示フラグ
  const [selectedGW, setSelectedGW] = useState(''); //選択したゲートウェイのID
  const [apiWaitList, setAPIWaitList] = useState<string[]>([]); //引継ぎAPI待機中のゲートウェイのリスト
  const [isOpenRebootDialog, setIsOpenRebootDialog] = useState(false); //再起動ダイアログ表示フラグ
  const [rebootGWTarget, setRebootGWTarget] = useState(''); //再起動をするゲートウェイのID
  const [isOpenConfigDialog, setIsOpenConfigDialog] = useState(false); //設定反映ダイアログ表示フラグ
  const [configGWTarget, setConfigGWTarget] = useState(''); //設定反映をするゲートウェイのID
  const [message, setMessage] = useState(''); //ゲートウェイ再起動・アップデート開始時のメッセージ
  const [rtUnitNumInfo, setRTUnitNumInfo] = useState<rtUnitNumInfoType[]>([]); //GW毎のQton,Hyozanの数
  const [isOpenErrorDialog, setIsOpenErrorDialog] = useState(false); //API使用時エラー発生ダイアログ表示フラグ
  const [noUnitGwList, setNoUnitGwList] = useState<string[]>([]); // ユニットが存在しないゲートウェイのリスト
  const [isOpenComTestDialog, setIsOpenComTestDialog] = useState(false); //通信テストダイアログ表示フラグ
  const [countDownFlag, setCountDownFlag] = useState(false); //減算処理実施フラグ
  const [startCommunicationTime, setStartCommunicationTime] = useState<
    {gwID: string; startTime: string}[]
  >([]); //通信テストの開始時間リスト
  const [restCommunicationTime, setRestCommunicationTime] = useState<
    {gwID: string; restTime: number}[]
  >([]); //通信テストの残り時間リスト
  const [state, setState] = useState<State>({
    open: false,
    vertical: 'top',
    horizontal: 'center',
  });
  const {vertical, horizontal, open} = state;
  const [isOpenCollectiveDialog, setIsOpenCollectiveDialog] = useState(false); //一括登録ダイアログ表示フラグ

  // ユニット台数を表示するグリッドのxs 合計12になるように設定する。
  const gridXSUnitType = 7.5;
  const gridXSColon = 1;
  const gridXSValue = 3.5;

  /** 支払いステータスの言語翻訳 */
  const paymentDisp = (
    billingStatus:
      | apiIF.res.getCompositionsGateway['gateway-informations'][0]['billing-status']
      | undefined
  ) => {
    if (billingStatus === undefined) return '';
    const message = {
      unpaid: trans('GWSetting.paidStatus.unpaid'),
      paid: trans('GWSetting.paidStatus.paid'),
      failed: trans('GWSetting.paidStatus.failed'),
      canceled: trans('GWSetting.paidStatus.canceled'),
    };
    return message[billingStatus];
  };

  //ゲートウェイの情報を取得
  useEffect(() => {
    //パスパラメータを取得できない場合
    if (siteID === undefined) return;

    getCompositionsGateway(siteID, {'max-result': 100})
      .then(resInfo => {
        //残り時間カウント用に配列をコピー
        setStartCommunicationTime(
          resInfo['gateway-informations'].reduce((result, response) => {
            if (response['communication-test-time'] !== undefined) {
              result.push({
                gwID: response['gateway-id'],
                startTime: response['communication-test-time'],
              });
            }
            return result;
          }, [] as {gwID: string; startTime: string}[])
        );
        //通信テスト残り時間の初期値を設定する
        setRestCommunicationTime(
          resInfo['gateway-informations'].reduce((result, response) => {
            if (response['communication-test-time'] !== undefined) {
              //現在時間と通信テスト開始時間の時間差(ミリ秒)
              const diffTime =
                Date.now() -
                new Date(response['communication-test-time']).getTime();
              result.push({
                gwID: response['gateway-id'],
                restTime:
                  limit.COMMUNICATION_TEST_TIME - Math.floor(diffTime / 1000),
              });
            }
            return result;
          }, [] as {gwID: string; restTime: number}[])
        );
        countDown();
        //表示内容をUnicode順に並び替え
        resInfo = gwInfoSort(resInfo);
        props.setGWInfo(resInfo);

        let updateGW = [];
        let updateVersion: {[key: string]: string} = {};
        //Updateの有無をチェック
        for (const gwInfo of resInfo['gateway-informations']) {
          //アップデート情報が無い場合は次のゲートウェイへ
          if (
            gwInfo['gateway-update-version'] === undefined ||
            gwInfo['gateway-update-version'] === 'latest' ||
            gwInfo['gateway-update-version'] === ''
          ) {
            continue;
          }
          //アップデート情報がある場合は、Updateボタンを表示し、次バージョン情報を記憶
          updateGW.push(gwInfo['gateway-id']);
          updateVersion[gwInfo['gateway-id']] =
            gwInfo['gateway-update-version'];
        }
        setHasUpdateGW(updateGW);
        setUpdateGWVersion(updateVersion);

        let configCheck = [];
        //構成情報未反映の有無をチェック
        for (const gwInfo of resInfo['gateway-informations']) {
          //アップデート不要の場合は次のゲートウェイへ
          if (
            gwInfo['composition-receipt-version'] === undefined ||
            gwInfo['composition-receipt-version'] === 'latest'
          ) {
            continue;
          }
          //アップデート情報がある場合は、Configボタンを表示
          configCheck.push(gwInfo['gateway-id']);
          setHasConfigGW(configCheck);
        }

        //GW毎のRT機器の数を取得
        const rtNumPromises = resInfo['gateway-informations']
          .filter(gwInfo => gwInfo['system'] === 'rt')
          .map(async gwInfo => {
            try {
              //熱源機の情報を取得
              const query = {'max-result': 400};
              const rtInfo = await getCompositionsRTUnit(
                siteID,
                gwInfo['gateway-id'],
                query
              );

              let tempQtonNum = 0;
              let tempHyozanNum = 0;
              let tempChillerNum = 0;
              for (const unitInfo of rtInfo['unit-informations']) {
                switch (unitInfo['unit-type']) {
                  case 'QtonOpen':
                  case 'QtonClose':
                    tempQtonNum++;
                    break;
                  case 'Hyozan':
                    tempHyozanNum++;
                    break;
                  case 'Chiller':
                    tempChillerNum++;
                    break;
                  default:
                    break;
                }
              }
              return {
                gatewayID: gwInfo['gateway-id'],
                qtonNum: tempQtonNum,
                hyozanNum: tempHyozanNum,
                chillerNum: tempChillerNum,
              };
            } catch (error) {
              throw error;
            }
          });
        return Promise.all(rtNumPromises);
      })
      .then(result => {
        setRTUnitNumInfo(result);
      })
      .catch(error => {
        apiErrorAlert(trans);
      });
  }, []);

  /**
   * ゲートウェイ情報が更新されるごとにユニットの有無を確認する
   */
  useEffect(() => {
    if (props.gwInfo === null) {
      return;
    }
    let noUnitGWList: string[] = []; // ユニットが存在しないゲートウェイのIDを含む配列
    props.gwInfo['gateway-informations'].forEach(gw => {
      // ユニットの有無の確認、ユニットがない初期状態ではUpdate、ConfigUpdateボタンを表示しない
      if (
        gw['register-number'] === undefined ||
        (gw['register-number']['sl-system-1']['outdoor-unit'] === '0' &&
          gw['register-number']['sl-system-1']['indoor-unit'] === '0' &&
          gw['register-number']['sl-system-2']['outdoor-unit'] === '0' &&
          gw['register-number']['sl-system-2']['indoor-unit'] === '0' &&
          gw['register-number']['rt-system-1']['rt-unit'] === '0' &&
          gw['register-number']['rt-system-2']['rt-unit'] === '0' &&
          gw['register-number']['modbus-system']['outdoor-unit'] === '0')
      ) {
        noUnitGWList.push(gw['gateway-id']);
      }
    });
    setNoUnitGwList(noUnitGWList);
  }, [props.gwInfo]);

  //10秒毎にゲートウェイ情報を取得する
  useEffect(() => {
    //パスパラメータを取得できない場合
    if (siteID === undefined) return;

    const intervalId = setInterval(() => {
      setNow(new Date()); //useEffectが実行される度に、stateを更新し、次のuseEffectを実行する
      //ゲートウェイの情報を取得
      getCompositionsGateway(siteID, {'max-result': 100}).then(response => {
        //ページ遷移が起こると、タイマ削除は働くが、useEffectは動作しないので、タイマが止まる
        //表示内容をUnicode順に並び替え
        response = gwInfoSort(response);
        props.setGWInfo(response);
      });
    }, 10000);

    //10秒毎にタイマを削除
    return function () {
      clearInterval(intervalId);
    };
  }, [now]);

  //set intervalは起動時点のstate値を記憶する。以降のカウントダウンでは常に
  //初期値からデクリメントするため、正しくカウントダウンできない。
  //そこで、カウントダウン毎に値を取得する仕組みとしている
  const refStartCommunicationTime = useRef(startCommunicationTime);
  useEffect(() => {
    refStartCommunicationTime.current = startCommunicationTime;
  }, [startCommunicationTime]);

  /**
   * 1秒毎に通信テストの残り時間を更新する
   */
  const countDown = () => {
    if (countDownFlag) return;
    setInterval(() => {
      setRestCommunicationTime(
        refStartCommunicationTime.current.map(info => {
          //現在時間と通信テスト開始時間の時間差(ミリ秒)
          const diffTime = Date.now() - new Date(info['startTime']).getTime();
          //通信テストの残り時間
          const restTime =
            limit.COMMUNICATION_TEST_TIME - Math.floor(diffTime / 1000);
          return {
            gwID: info.gwID,
            restTime: restTime,
          };
        })
      );
    }, 1000);
    //setIntervalが複数回実行されないようフラグで管理
    //ページリロード時は初期値でfalseとなる
    setCountDownFlag(true);
  };

  /**
   * ゲートウェイの通信設定を表示する文字列を作成
   * @param system 通信設定
   * @param slType SL新旧
   * @returns 表示する文字列
   */
  const makeGWtypeValue = (system: string, slType: string) => {
    if (system === 'sl') {
      return trans(
        `GWSetting.item.value.gatewayType.superlink${initialUpper(slType)}`,
        {defaultValue: ''} //slTypeが'new' or 'old'以外の場合
      );
    }
    return trans('GWSetting.item.value.gatewayType.remoteTerminal');
  };

  /**
   * ゲートウェイ再起動・遠隔アップデート開始時のスナックバー表示処理
   */
  const handleClose = () => {
    setState({...state, open: false});
  };
  /**
   * UPDATEボタン押下時処理
   * @param gwID ゲートウェイID
   * @param version 現在のゲートウェイのバージョン
   */
  const specifyUpdateTarget = (gwID: string, version: string | undefined) => {
    if (version === undefined) return;
    setUpdateTarget(gwID);
    setNowGWVersion(version);
    setIsOpenUpdateDialog(true);
  };
  /**
   * CGWの遠隔アップデート開始ボタン押下時処理
   */
  const updateExec = () => {
    //パスパラメータを取得できない場合
    if (siteID === undefined) return;

    setClickButton(true);

    //サイトの情報を取得
    getCompositionsSitesBySiteID(siteID)
      .then(response => {
        let dateNow = new Date();
        let now = format(
          utcToZonedTime(dateNow, response['timezone']),
          'yyyy-MM-dd HH:mm:ss'
        );
        let date = zonedTimeToUtc(now, response['timezone']).toISOString();

        const body: apiIF.reqParameters.postCommandsGateway = {
          date: date,
          mode: 'program-update',
        };
        //アップデートを実施
        return postCommandsGateway(siteID, updateTarget, body);
      })
      .then(response => {
        //アップデート完了後、Updateボタンを非表示とする。次回ページリロード時に次アップデート表示をする
        setHasUpdateGW(hasUpdateGW.filter(gwID => gwID !== updateTarget));
        setMessage(`${trans('GWSetting.executionResult.update')}`);
        setState({open: true, vertical: 'top', horizontal: 'center'});
      })
      .catch(err => {
        alert(trans('GWSetting.alertMsg.operationErr'));
      })
      .finally(() => {
        setClickButton(false);
        setIsOpenUpdateDialog(false);
      });
  };
  /**
   * Editボタン押下時処理
   * @param gwID ゲートウェイID
   */
  const openEditDialog = (gwID: string) => {
    setIsOpenEditDialog(true);
    setSelectedGW(gwID);
  };
  /**
   * collectiveSetting押下時処理
   * @param gwID ゲートウェイID
   */
  const collectiveSettingDialog = (gwID: string) => {
    setIsOpenCollectiveDialog(true);
    setSelectedGW(gwID);
  };
  /**
   * Deleteボタン押下時処理
   * @param gwID ゲートウェイID
   */
  const openDeleteDialog = (gwID: string) => {
    setIsOpenDeleteDialog(true);
    setSelectedGW(gwID);
  };
  /**
   * Rebootボタン押下時処理
   * @param gwID ゲートウェイID
   */
  const rebootDialogExec = (gwID: string) => {
    setIsOpenRebootDialog(true);
    setRebootGWTarget(gwID);
  };
  /**
   * CommunicationTestボタン押下時処理
   * @param gwID ゲートウェイID
   */
  const openComTestDialog = (gwID: string) => {
    setIsOpenComTestDialog(true);
    setSelectedGW(gwID);
  };
  /**
   * Config Updateボタン押下時処理
   * @param gwID ゲートウェイID
   */
  const configurationDialogExec = (gwID: string) => {
    setIsOpenConfigDialog(true);
    setConfigGWTarget(gwID);
  };
  /**
   * 構成情報更新ボタン押下時処理
   * @param gwID ゲートウェイID
   */
  const applyExecConfig = (gwID: string) => {
    //パスパラメータを取得できない場合
    if (siteID === undefined) return;

    setClickButton(true);

    //サイトの情報を取得
    getCompositionsSitesBySiteID(siteID)
      .then(response => {
        let dateNow = new Date();
        let now = format(
          utcToZonedTime(dateNow, response['timezone']),
          'yyyy-MM-dd HH:mm:ss'
        );
        let date = zonedTimeToUtc(now, response['timezone']).toISOString();
        const body: apiIF.reqParameters.postCommandsGateway = {
          date: date,
          mode: 'configuration-update',
        };
        //Rebootを実施
        return postCommandsGateway(siteID, gwID, body);
      })
      .then(response => {
        //反映完了後、Configボタンを非表示とする。
        setHasConfigGW(hasConfigGW.filter(gwID => gwID !== configGWTarget));
        setMessage(`${trans('GWSetting.executionResult.reboot')}`);
        setState({open: true, vertical: 'top', horizontal: 'center'});
      })
      .catch(err => {
        alert(trans('GWSetting.alertMsg.operationErr'));
      })
      .finally(() => {
        setIsOpenConfigDialog(false);
        setClickButton(false);
      });
  };
  /**
   * Transferボタン押下時処理
   * @param gwID ゲートウェイID
   */
  const transferExec = (gwID: string, gwName: string | undefined) => {
    //データを取得できない場合
    if (siteID === undefined || gwName === undefined) {
      return;
    }
    // 引継ぎAPI待機中のゲートウェイリストに追加
    let addList = apiWaitList;
    addList.push(gwID);
    setAPIWaitList(addList);
    //引継ぎゲートウェイの追加
    postCompositionsActivation(siteID, {
      'gateway-name': gwName,
      'gateway-id': gwID,
    })
      .then(() => {
        //仮登録されたゲートウェイの情報を取得
        return getCompositionsActivation(siteID, {'max-result': 100});
      })
      .then(response => {
        //表示内容をUnicode順に並び替え
        response['gateway-informations'].sort(sortByUnicode('gateway-name'));
        // アクティベーション有効期限
        props.setRestActivationTime(
          response['gateway-informations'].map(info => info['time-remaining'])
        );
        // 仮登録ゲートウェイの一覧更新
        props.setTempActivateGW(response);
        // 引継ぎ実施中の登録済みゲートウェイのIDリスト更新
        let exchangeGWList: Array<string> = [];
        response['gateway-informations'].forEach(info => {
          if (info['exchange-gateway-id'] !== '') {
            exchangeGWList.push(info['exchange-gateway-id']);
          }
        });
        props.setExchangeGW(exchangeGWList);
      })
      .catch(() => {
        setIsOpenErrorDialog(true);
      })
      .finally(() => {
        // ページ最上部に移動
        window.scroll({top: 0, behavior: 'smooth'});
        // 引継ぎAPI待機中のゲートウェイリストから今回追加した分を削除
        let deleteList = apiWaitList;
        deleteList.splice(deleteList.indexOf(gwID), 1);
        setAPIWaitList(deleteList);
      });
  };

  /**
   * CGW再起動ボタン押下時処理
   * @param gwID ゲートウェイID
   */
  const applyExecReboot = (gwID: string) => {
    //パスパラメータを取得できない場合
    if (siteID === undefined) return;

    setClickButton(true);

    //サイトの情報を取得
    getCompositionsSitesBySiteID(siteID)
      .then(response => {
        let dateNow = new Date();
        let now = format(
          utcToZonedTime(dateNow, response['timezone']),
          'yyyy-MM-dd HH:mm:ss'
        );
        let date = zonedTimeToUtc(now, response['timezone']).toISOString();
        const body: apiIF.reqParameters.postCommandsGateway = {
          date: date,
          mode: 'gateway-reset',
        };
        //Rebootを実施
        return postCommandsGateway(siteID, gwID, body);
      })
      .then(response => {
        setMessage(`${trans('GWSetting.executionResult.reboot')}`);
        setState({open: true, vertical: 'top', horizontal: 'center'});
      })
      .catch(err => {
        alert(trans('GWSetting.alertMsg.operationErr'));
      })
      .finally(() => {
        setIsOpenRebootDialog(false);
        setClickButton(false);
      });
  };

  /**
   * 歯車メニューリスト
   * @param gwID ゲートウェイID
   * @param gwName ゲートウェイ名
   * @param gwSystem ゲートウェイシステム
   * @returns メニュー一覧
   */
  const gearMenuItem = (
    gwID: string,
    gwName: string | undefined,
    gwSystem: apiIF.resParameters.gatewayInformations['system']
  ): GearMenuListArgType['menuItem'] => {
    const gwMenuItem: GearMenuListArgType['menuItem'] = [];
    gwMenuItem.push({
      label: trans('GWSetting.menuItem.edit'),
      onClick: () => openEditDialog(gwID),
      icon: {
        className: 'gwSetting__contents__button__icon',
        src: iconBlack.EDIT.src,
        alt: trans(`GWSetting.image.alternativeText.${iconBlack.EDIT.alt}`),
      },
    });
    // SL通信の場合のみ一括登録を有効にする。
    if (gwSystem === 'sl') {
      gwMenuItem.push({
        label: trans('GWSetting.menuItem.collectiveSetting'),
        onClick: () => collectiveSettingDialog(gwID),
        icon: {
          className: 'gwSetting__contents__button__icon',
          src: iconBlack.EDIT.src,
          alt: trans(`GWSetting.image.alternativeText.${iconBlack.EDIT.alt}`),
        },
      });
    }
    gwMenuItem.push({
      label: trans('GWSetting.menuItem.transfer'),
      onClick: () => transferExec(gwID, gwName),
      MuiIcon: () => (
        <MoveUpOutlinedIcon
          className="gwSetting__contents__button__icon"
          color="secondary"
        />
      ),
    });
    gwMenuItem.push({
      label: trans('GWSetting.menuItem.delete'),
      onClick: () => openDeleteDialog(gwID),
      icon: {
        className: 'gwSetting__contents__button__icon',
        src: iconBlack.DELETE.src,
        alt: trans(`GWSetting.image.alternativeText.${iconBlack.DELETE.alt}`),
      },
    });
    gwMenuItem.push({
      label: trans('GWSetting.menuItem.reboot'),
      onClick: () => rebootDialogExec(gwID),
      MuiIcon: () => <AutorenewIcon color="secondary" />,
      disabled: noUnitGwList.includes(gwID),
    });
    gwMenuItem.push({
      label: trans('GWSetting.menuItem.communicationTest'),
      onClick: () => openComTestDialog(gwID),
      MuiIcon: () => <LeakAddIcon color="secondary" />,
    });
    gwMenuItem.push({
      label: trans('GWSetting.menuItem.configUpdate'),
      onClick: () => configurationDialogExec(gwID),
      MuiIcon: () => <UpgradeIcon color="secondary" />,
      disabled: noUnitGwList.includes(gwID),
    });
    return gwMenuItem;
  };

  /**
   * 通信テスト開始時間を取得する
   * @param gwID
   */
  const updateComTestStartTime = (gwID: string) => {
    //パスパラメータを取得できない場合
    if (siteID === undefined) return;
    // 通信テスト開始時間に更新があったゲートウェイの情報を取得
    getCompositionsGatewayByGatewayID(siteID, gwID)
      .then(gwInfo => {
        //残り時間カウント用に通信テストの開始時間をコピー
        setStartCommunicationTime(
          refStartCommunicationTime.current.map(startTimeInfo => {
            if (startTimeInfo.gwID !== gwID) {
              return startTimeInfo;
            }
            return {
              gwID: startTimeInfo.gwID,
              startTime: gwInfo['communication-test-time'],
            };
          })
        );
      })
      .catch(() => {
        alert(trans('GWSetting.alertMsg.operationErr'));
      });
  };

  /**
   * SL通信設定のゲートウェイに登録されている空調機の台数を表示する文字列を作成
   * @param props props
   * @returns JSX
   * - registerNumInfo 台数情報
   */
  const MakeSLValue = (props: {
    registerNumInfo: {
      'sl-system-1': {'outdoor-unit': string; 'indoor-unit': string};
      'sl-system-2': {'outdoor-unit': string; 'indoor-unit': string};
      'rt-system-1': {'rt-unit': string; 'indoor-unit': string};
      'rt-system-2': {'rt-unit': string; 'indoor-unit': string};
      'modbus-system': {'outdoor-unit': string; 'indoor-unit': string};
    };
  }) => {
    //室外機の台数を算出
    const ouAllNum =
      Number(props.registerNumInfo['sl-system-1']['outdoor-unit']) +
      Number(props.registerNumInfo['sl-system-2']['outdoor-unit']);
    //室内機の台数を算出
    const iuAllNum =
      Number(props.registerNumInfo['sl-system-1']['indoor-unit']) +
      Number(props.registerNumInfo['sl-system-2']['indoor-unit']);

    return (
      <Grid container>
        <Grid item xs={gridXSValue}>
          {trans('GWSetting.item.value.units.outdoorUnit')}
        </Grid>
        <Grid item xs={gridXSColon}>
          :
        </Grid>
        <Grid item xs={gridXSUnitType}>
          {ouAllNum}&nbsp;{trans('GWSetting.item.value.units.unit')}
        </Grid>
        <Grid item xs={gridXSValue}>
          {trans('GWSetting.item.value.units.indoorUnit')}
        </Grid>
        <Grid item xs={gridXSColon}>
          :
        </Grid>
        <Grid item xs={gridXSUnitType}>
          {iuAllNum}&nbsp;{trans('GWSetting.item.value.units.unit')}
        </Grid>
      </Grid>
    );
  };
  /**
   * RT通信設定のゲートウェイに登録されている空調機の台数を表示する文字列を作成
   * @param gatewayID ゲートウェイID
   * @returns JSX
   */
  const MakeRTValue = (props: {gatewayID: string}) => {
    if (rtUnitNumInfo.length === 0) {
      //API取得前は待ちサイクル
      return <CircularProgress size={20} />;
    }

    const currentGW = rtUnitNumInfo.find(data => {
      return data.gatewayID === props.gatewayID;
    });
    if (currentGW === undefined) {
      return <CircularProgress size={20} />;
    }
    return (
      <Grid container>
        <Grid item xs={gridXSValue} key={`${currentGW.gatewayID}qton`}>
          {trans('GWSetting.item.value.units.qton')}
        </Grid>
        <Grid item xs={gridXSColon}>
          :
        </Grid>
        <Grid item xs={gridXSUnitType}>
          {currentGW.qtonNum}&nbsp;
          {trans('GWSetting.item.value.units.unit')}
        </Grid>
        <Grid item xs={gridXSValue} key={`${currentGW.gatewayID}chiller`}>
          {trans('GWSetting.item.value.units.chiller')}
        </Grid>
        <Grid item xs={gridXSColon}>
          :
        </Grid>
        <Grid item xs={gridXSUnitType}>
          {currentGW.chillerNum}&nbsp;
          {trans('GWSetting.item.value.units.unit')}
        </Grid>
      </Grid>
    );
  };
  /**
   * Modbus通信設定のゲートウェイに登録されている空調機の台数を表示する文字列を作成
   * @param props props
   * @returns JSX
   * - registerNumInfo 台数情報
   */
  const MakeModbusValue = (props: {
    registerNumInfo: {
      'sl-system-1': {'outdoor-unit': string; 'indoor-unit': string};
      'sl-system-2': {'outdoor-unit': string; 'indoor-unit': string};
      'rt-system-1': {'rt-unit': string; 'indoor-unit': string};
      'rt-system-2': {'rt-unit': string; 'indoor-unit': string};
      'modbus-system': {'outdoor-unit': string; 'indoor-unit': string};
    };
    gatewayID: string;
  }) => {
    // Hyozan室外機台数の取得
    // 取得失敗の場合は0台とする
    let hyozanOUNum = 0;
    if (rtUnitNumInfo.length > 0) {
      const currentGW = rtUnitNumInfo.find(
        data => data.gatewayID === props.gatewayID
      );
      if (currentGW !== undefined) {
        hyozanOUNum = currentGW.hyozanNum;
      }
    }

    //室外機の台数を算出
    const ouAllNum =
      Number(hyozanOUNum) +
      Number(props.registerNumInfo['modbus-system']['outdoor-unit']);
    //室内機の台数を算出
    const iuAllNum =
      Number(props.registerNumInfo['rt-system-1']['indoor-unit']) +
      Number(props.registerNumInfo['rt-system-2']['indoor-unit']) +
      Number(props.registerNumInfo['modbus-system']['indoor-unit']);

    if (ouAllNum === 0 && ouAllNum === 0) {
      return <></>;
    }
    return (
      <CardContents
        class="gwSetting__contents__contents__underLine"
        valueDescription={trans('GWSetting.item.title.hccvqUnits')}
        value={
          <Grid container>
            <Grid item xs={gridXSValue}>
              {trans('GWSetting.item.value.units.outdoorUnit')}
            </Grid>
            <Grid item xs={gridXSColon}>
              :
            </Grid>
            <Grid item xs={gridXSUnitType}>
              {ouAllNum}&nbsp;
              {trans('GWSetting.item.value.units.unit')}
            </Grid>
            <Grid item xs={gridXSValue}>
              {trans('GWSetting.item.value.units.indoorUnit')}
            </Grid>
            <Grid item xs={gridXSColon}>
              :
            </Grid>
            <Grid item xs={gridXSUnitType}>
              {iuAllNum}&nbsp;
              {trans('GWSetting.item.value.units.unit')}
            </Grid>
          </Grid>
        }
      />
    );
  };

  //API取得前は表示無し
  if (props.gwInfo === null) {
    return <></>;
  }
  //登録ゲートウェイが有る場合の処理
  return (
    <>
      {/* 登録済ゲートウェイの台数分ループ処理 */}
      {props.gwInfo['gateway-informations'].map(gwInfo => {
        /** 最終接続時刻 */
        const lastConnected =
          props.timeZone && gwInfo['received-time']
            ? utcToZonedTime(gwInfo['received-time'], props.timeZone)
            : '';
        return (
          <Card
            id={`mv-boxGw${gwInfo['gateway-id']}`}
            key={`mv-boxGw${gwInfo['gateway-id']}`}
            className="gwSetting__contents--gw">
            <CardContent>
              <Stack spacing={4}>
                {/* 状態値とゲートウェイの名前とボタン */}
                <Grid
                  container
                  className="gwSetting__contents__title"
                  spacing={1}
                  justifyContent="flex-end">
                  {/* 現在のゲートウェイの状態値マーク */}
                  <Grid item xs={1}>
                    {apiWaitList.includes(gwInfo['gateway-id']) ? (
                      <CircularProgress size={35} />
                    ) : (
                      <img
                        className="gwSetting__contents__successMark"
                        src={iconBlack.SUCCESS.src}
                        alt={`${trans(
                          `GWSetting.image.alternativeText.${iconBlack.SUCCESS.alt}`
                        )}`}
                      />
                    )}
                  </Grid>
                  {/* ゲートウェイの名前 */}
                  <Grid item xs={5}>
                    <Link
                      to={`${location.pathname}/${gwInfo['gateway-id']}/communication${location.search}`}
                      id={`mv-linkGwSetting${gwInfo['gateway-name']}`}>
                      {gwInfo['gateway-name']}
                    </Link>
                    {/* 引継ぎ実施中の場合は名称の後ろに実施中と表記する */}
                    {props.exchangeGW.includes(gwInfo['gateway-id'])
                      ? ` (${trans('GWSetting.exchangeGateway')})`
                      : ''}
                  </Grid>
                  <Grid item xs={5}>
                    <Grid container justifyContent="flex-end" spacing={1}>
                      {/* Updateボタン */}
                      {props.exchangeGW.includes(gwInfo['gateway-id']) ||
                      apiWaitList.includes(gwInfo['gateway-id']) ||
                      hasUpdateGW.includes(gwInfo['gateway-id']) === false ? (
                        <></>
                      ) : (
                        <Grid item xs="auto">
                          <Button
                            variant="outlined"
                            color="primary"
                            onClick={() =>
                              specifyUpdateTarget(
                                gwInfo['gateway-id'],
                                gwInfo['gateway-version']
                              )
                            }
                            id="mv-btnUpdateGw"
                            startIcon={<UpgradeIcon />}>
                            {trans('GWSetting.buttonTxt.update')}
                          </Button>
                        </Grid>
                      )}
                      {/* Config Updateボタン */}
                      {props.exchangeGW.includes(gwInfo['gateway-id']) ||
                      apiWaitList.includes(gwInfo['gateway-id']) ||
                      noUnitGwList.includes(gwInfo['gateway-id']) ||
                      hasConfigGW.includes(gwInfo['gateway-id']) === false ? (
                        <></>
                      ) : (
                        <Grid item xs={'auto'}>
                          <Button
                            variant="outlined"
                            color="primary"
                            onClick={() =>
                              configurationDialogExec(gwInfo['gateway-id'])
                            }
                            id="mv-btnUpdateGw"
                            startIcon={<UpgradeIcon />}>
                            {trans('GWSetting.buttonTxt.configUpdate')}
                          </Button>
                        </Grid>
                      )}
                    </Grid>
                  </Grid>
                  {/* 歯車ボタン */}
                  <Grid item xs={1}>
                    {/* 引継ぎ実施中のゲートウェイは歯車ボタンを非表示 */}
                    {props.exchangeGW.includes(gwInfo['gateway-id']) ||
                    apiWaitList.includes(gwInfo['gateway-id']) ? (
                      <></>
                    ) : (
                      <GearMenu
                        id={`mv-btnGwSettingOpen${gwInfo['gateway-id']}`}
                        menuItem={gearMenuItem(
                          gwInfo['gateway-id'],
                          gwInfo['gateway-name'],
                          gwInfo['system']
                        )}
                      />
                    )}
                    {/* gwIDをチェックして選択したゲートウェイのダイアログのみ出す */}
                    {gwInfo['gateway-id'] === selectedGW &&
                    gwInfo['gateway-name'] !== undefined ? (
                      <>
                        <GWEditDialog
                          displayGWInfo={gwInfo}
                          setGWInfo={props.setGWInfo}
                          isOpenDialog={isOpenEditDialog}
                          setIsOpenDialog={setIsOpenEditDialog}
                        />
                        <GWDeleteDialog
                          gwID={gwInfo['gateway-id']}
                          gwName={gwInfo['gateway-name']}
                          gwBillingStatus={gwInfo['billing-status']}
                          setGWInfo={props.setGWInfo}
                          isOpenDialog={isOpenDeleteDialog}
                          setIsOpenDialog={setIsOpenDeleteDialog}
                        />
                        {gwInfo['sl-type'] !== undefined &&
                          gwInfo['sl-type'] !== '' && (
                            <CollectiveSettingDialog
                              gwID={gwInfo['gateway-id']}
                              gwName={gwInfo['gateway-name']}
                              slType={gwInfo['sl-type']}
                              isOpenDialog={isOpenCollectiveDialog}
                              setIsOpenDialog={setIsOpenCollectiveDialog}
                              hasConfigGW={hasConfigGW}
                              setHasConfigGW={setHasConfigGW}
                            />
                          )}
                        <CommunicationTest
                          gwID={gwInfo['gateway-id']}
                          isOpenDialog={isOpenComTestDialog}
                          setIsOpenDialog={setIsOpenComTestDialog}
                          restCommunicationTime={
                            //prettier-ignore
                            //コンパイルエラーとなるため非nullアサーションを用いているが、
                            //undefinedの場合は以下ではじいているため問題ない。
                            restCommunicationTime.find(info => info.gwID === gwInfo['gateway-id']) === undefined
                            ? 0
                            : restCommunicationTime.find(info => info.gwID === gwInfo['gateway-id'])!.restTime
                          }
                          updateComTestStartTime={updateComTestStartTime}
                        />
                      </>
                    ) : (
                      <></>
                    )}
                  </Grid>
                </Grid>
                {/* ゲートウェイの情報 */}
                <Stack spacing={2} className="gwSetting__contents__contents">
                  {/* アクティベーションステータス */}
                  <CardContents
                    class="gwSetting__contents__contents__underLine"
                    valueDescription={trans(
                      'GWSetting.item.title.activationStatus'
                    )}
                    value={`${trans('GWSetting.item.value.activationStatus')}`}
                    valueID={`mv-txtGwActivationStatus${gwInfo['gateway-name']}`}
                  />
                  <CardContents
                    class="gwSetting__contents__contents__underLine"
                    valueDescription={trans(
                      'GWSetting.item.title.paymentStatus'
                    )}
                    value={paymentDisp(gwInfo['billing-status'])}
                    valueID={`mv-txtGwPaymentStatus${gwInfo['gateway-name']}`}
                  />
                  {/* 最終接続時刻 */}
                  <CardContents
                    class="gwSetting__contents__contents__underLine"
                    valueDescription={trans(
                      'GWSetting.item.title.lastConnected'
                    )}
                    value={
                      lastConnected === ''
                        ? ''
                        : //prettier-ignore
                          `${trans('GWSetting.item.value.lastConnected', {
                            year: lastConnected.getFullYear(),
                            month: String(lastConnected.getMonth() + 1).padStart(2, '0'),
                            date: String(lastConnected.getDate()).padStart(2, '0'),
                            hour: String(lastConnected.getHours()).padStart(2, '0'),
                            minutes: String(lastConnected.getMinutes()).padStart(2, '0'),
                          })}`
                    }
                    valueID={`mv-txtGwLastConnect${gwInfo['gateway-name']}`}
                  />
                  {/* IPアドレス */}
                  <CardContents
                    class="gwSetting__contents__contents__underLine"
                    valueDescription={trans('GWSetting.item.title.ipAddress')}
                    value={
                      gwInfo['ip-address'] === undefined
                        ? ''
                        : gwInfo['ip-address']
                    }
                  />
                  {/* ゲートウェイバージョン */}
                  <CardContents
                    class="gwSetting__contents__contents__underLine"
                    valueDescription={trans(
                      'GWSetting.item.title.gatewayVersion'
                    )}
                    value={
                      gwInfo['gateway-version'] === undefined
                        ? ''
                        : gwInfo['gateway-version']
                    }
                  />
                  {/* ゲートウェイタイプ */}
                  <CardContents
                    class="gwSetting__contents__contents__underLine"
                    valueDescription={trans('GWSetting.item.title.gatewayType')}
                    value={
                      gwInfo['system'] === undefined ||
                      gwInfo['sl-type'] === undefined
                        ? ''
                        : makeGWtypeValue(gwInfo['system'], gwInfo['sl-type'])
                    }
                  />
                  {/* 登録機(空調機 or Qton or Chiller) */}
                  {gwInfo['system'] === 'sl' &&
                  gwInfo['register-number'] !== undefined ? (
                    <CardContents
                      class="gwSetting__contents__contents__underLine"
                      valueDescription={trans('GWSetting.item.title.units')}
                      value={
                        <MakeSLValue
                          registerNumInfo={gwInfo['register-number']}
                        />
                      }
                    />
                  ) : (
                    <CardContents
                      class="gwSetting__contents__contents__underLine"
                      valueDescription={trans('GWSetting.item.title.units')}
                      value={<MakeRTValue gatewayID={gwInfo['gateway-id']} />}
                    />
                  )}
                  {/* 登録機(HCCV(Q)) */}
                  {gwInfo['register-number'] !== undefined ? (
                    <MakeModbusValue
                      registerNumInfo={gwInfo['register-number']}
                      gatewayID={gwInfo['gateway-id']}
                    />
                  ) : (
                    <></>
                  )}
                </Stack>
              </Stack>
            </CardContent>
          </Card>
        );
      })}
      {/* ゲートウェイ再起動・遠隔アップデート開始時のメッセージ */}
      <Snackbar
        anchorOrigin={{vertical, horizontal}}
        open={open}
        onClose={handleClose}
        message={message}
        key={vertical + horizontal}
      />
      {/* ゲートウェイの再起動ダイアログ */}
      <Dialog
        open={isOpenRebootDialog}
        onClose={() => setIsOpenRebootDialog(false)}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        id={'RebootDialog'}>
        <DialogTitle id="alert-dialog-title">
          {trans('GWSetting.dialogBox.reboot.title')}
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            {trans('GWSetting.dialogBox.reboot.msg')}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <SecondaryButton
            onClick={() => setIsOpenRebootDialog(false)}
            buttonText={trans('GWSetting.dialogBox.buttonTxt.cancel')}
            id="RebootDialogBtnCancel"
          />
          {/* API完了後、画面遷移 */}
          <PrimaryButton
            onClick={() => applyExecReboot(rebootGWTarget)}
            buttonText={trans('GWSetting.dialogBox.buttonTxt.ok')}
            id="RebootDialogBtnOK"
            disabled={clickButton}
            apiWait={clickButton}
          />
        </DialogActions>
      </Dialog>
      {/* 構成情報反映ダイアログ */}
      <Dialog
        open={isOpenConfigDialog}
        onClose={() => setIsOpenConfigDialog(false)}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        id={'RebootDialog'}>
        <DialogTitle id="alert-dialog-title">
          {trans('GWSetting.dialogBox.configUpdate.title')}
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            {trans('GWSetting.dialogBox.configUpdate.msg')}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <SecondaryButton
            onClick={() => setIsOpenConfigDialog(false)}
            buttonText={trans('GWSetting.dialogBox.buttonTxt.cancel')}
            id="RebootDialogBtnCancel"
          />
          {/* API完了後、画面遷移 */}
          <PrimaryButton
            onClick={() => applyExecConfig(configGWTarget)}
            buttonText={trans('GWSetting.dialogBox.buttonTxt.ok')}
            className="btnOK"
            id="RebootDialogBtnOK"
            disabled={clickButton}
            apiWait={clickButton}
          />
        </DialogActions>
      </Dialog>
      {/* 遠隔アップデートのダイアログ */}
      <Dialog
        open={isOpenUpdateDialog}
        onClose={() => setIsOpenUpdateDialog(false)}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        id="Update-Dialog">
        <DialogTitle id="alert-dialog-title">
          {trans('GWSetting.dialogBox.update.title')}
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            {trans('GWSetting.dialogBox.update.msg', {
              nowVersion: nowGWVersion,
              newVersion: updateGWVersion[updateTarget],
            })}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <SecondaryButton
            disabled={clickButton}
            onClick={() => setIsOpenUpdateDialog(false)}
            buttonText={trans('GWSetting.dialogBox.buttonTxt.cancel')}
            id="mv-btnCancel-Update"
          />
          <PrimaryButton
            onClick={updateExec}
            buttonText={trans('GWSetting.dialogBox.buttonTxt.ok')}
            className="btnOK"
            id="mv-btnOk-Update"
            disabled={clickButton}
            apiWait={clickButton}
          />
        </DialogActions>
      </Dialog>
      {/* エラー表示 */}
      <APIErrorMessage
        open={isOpenErrorDialog}
        setOpen={setIsOpenErrorDialog}
        id="mv-gwActivateErrDlgBtn"
      />
    </>
  );
};
export default GWSetting;
